/**
 * Okno potwierdzenia zamiast przegladarkowego confirm().
 *
 * Natywny <dialog> z showModal() daje trzy rzeczy, ktorych recznie robiony
 * nakladany element nie ma za darmo: pulapke na Tab (fokus nie ucieka na
 * strone pod spodem), warstwe nad calym dokumentem niezalezna od z-index oraz
 * Escape jako anulowanie.
 *
 * Klikniecie w tlo NIE zamyka okna. Natywny <dialog> tak wlasnie sie zachowuje
 * i to jest tu wlasciwe: pytanie dotyczy skasowania danych, a zamykanie takiego
 * pytania przypadkowym klknieciem obok bylo by proszeniem sie o klikniecie
 * "obok" w druga strone.
 */
import { esc } from './util'

export interface PytanieOpts {
  tytul: string
  tresc: string
  potwierdz?: string
  anuluj?: string
  /** Odpowiedz twierdzaca jest niszczaca - guzik dostaje barwe ostrzegawcza. */
  grozne?: boolean
}

export function pytanie(o: PytanieOpts): Promise<boolean> {
  const dlg = document.createElement('dialog')
  dlg.className = 'ask'
  dlg.innerHTML = `
    <form method="dialog">
      <h2>${esc(o.tytul)}</h2>
      <p>${esc(o.tresc)}</p>
      <menu>
        <button value="nie" class="btn">${esc(o.anuluj ?? 'Anuluj')}</button>
        <button value="tak" class="btn ${o.grozne ? 'danger' : 'primary'}"
                >${esc(o.potwierdz ?? 'OK')}</button>
      </menu>
    </form>`
  document.body.appendChild(dlg)

  return new Promise<boolean>(resolve => {
    dlg.addEventListener('close', () => {
      // Escape zamyka okno z pusta wartoscia - traktujemy to jak anulowanie,
      // bo przy pytaniu o skasowanie milczenie nie moze znaczyc zgody.
      resolve(dlg.returnValue === 'tak')
      dlg.remove()
    }, { once: true })

    dlg.showModal()
    // Fokus na guziku anulowania, nie na potwierdzeniu: Enter odruchowo
    // wcisniety zaraz po otwarciu ma nie kasowac projektu.
    dlg.querySelector<HTMLButtonElement>('button[value="nie"]')?.focus()
  })
}
